export function stringToUrl(str) {
    const input = (str === undefined || str === null) ? '' : str;
    return input.replace(/\W+/g, '-').toLowerCase()
}